























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import getActivityType from '@/common/utils/getActivityType';
@Component
export default class NoticeModal extends Vue {
  @Prop()
  show!: boolean;
  @Getter('mainTextColor')
  mainTextColor!: string;
  activityType: string = getActivityType();
  leftTime: number = 5;
  timer: any = null;
  @Watch('show')
  countDown() {
    if (this.show) {
      this.leftTime = 5;
      this.timer = window.setInterval(() => {
        if (this.leftTime) {
          this.leftTime = this.leftTime - 1;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    }
  }

  handleOk() {
    this.$emit('ok');
  }
  handleCancel() {
    clearInterval(this.timer);
    this.$emit('cancel');
  }
}
